import { render, staticRenderFns } from "./TodayRecommendation.vue?vue&type=template&id=cd5a62f2&scoped=true"
import script from "./TodayRecommendation.vue?vue&type=script&lang=js"
export * from "./TodayRecommendation.vue?vue&type=script&lang=js"
import style0 from "./TodayRecommendation.vue?vue&type=style&index=0&id=cd5a62f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5a62f2",
  null
  
)

export default component.exports